import React from "react";
import { formatDate } from "../../../../components/common/Converter";

export default function HRMSPrintMonetization({
  object,
  vacationLeave,
  sickLeave,
}) {
  console.log("DATA: ", object);

  const isSickOrVacation =
    object?.selectedType === "Sick Leave" ||
    object?.selectedType === "Vacation Leave";

  let current = 0;
  if (object?.selectedType === "Sick Leave") {
    current = sickLeave[0].current;
  }
  if (object?.selectedType === "Vacation Leave") {
    current = vacationLeave[0].current;
  }
  const dataPosition = (data, style) => {
    return (
      <div
        style={{
          width: "10rem",
          // border: "1px solid",
          position: "absolute",
          textAlign: "center",
          top: "14.1rem",
          left: "5.4rem",
          overflow: "hidden",
          whiteSpace: "nowrap",
          ...style,
        }}
      >
        {data}
      </div>
    );
  };
  return (
    <div
      style={{
        width: "8.27in", // Legal paper width
        height: "11.69in", // Legal paper height

        // border: "1px solid black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        marginLeft: "-10px",
        marginTop: "-10px",
        fontSize: "11px",
      }}
    >
      <img
        src="/leaveTemplate.png"
        style={{
          maxWidth: "100%", // Ensure image is not too large
          maxHeight: "100%", // Maintain aspect ratio
          objectFit: "contain", // Prevents stretching
        }}
        alt="Leave Template"
      />
      {/* data  */}
      {/* page 1 - 2 */}
      {dataPosition(object?.employee?.office, {})}
      {dataPosition(object?.employee?.surname, {
        left: "21.6rem",
        width: "6.5rem",
      })}
      {dataPosition(object?.employee?.Firstname, {
        left: "28.5rem",
        width: "6.8rem",
      })}
      {dataPosition(object?.employee?.Middlename, {
        left: "35.5rem",
        width: "6.5rem",
      })}
      {/* page 3 - 5 */}
      {dataPosition(formatDate(object?.createdAt), {
        left: "11.4rem",
        width: "5.2rem",
        top: "15.6rem",
      })}
      {dataPosition(object?.employee?.position?.position_title, {
        left: "23.1rem",
        width: "10.2rem",
        top: "15.6rem",
      })}
      {dataPosition(object?.employee?.salaryPointer?.["Monthly Rate"], {
        left: "37.5rem",
        width: "5.5rem",
        top: "15.6rem",
      })}
      {/* 6A */}
      {Array.from({ length: 13 }, (_, index) => {
        const leaveType = object?.selectedType; // Extract leaveType from data

        // Define a mapping of leave types to specific indexes
        const leaveTypeIndexes = {
          "Vacation Leave": [0],
          "Mandayory/Forced Leave": [1],
          "Sick Leave": [2],
          "Maternity Leave": [3],
          "Paternity Leave": [4],
          "Special Leave Privilege": [5],
          "Solo Parent Leave": [6],
          "Study Leave": [7],
          "10-Day VAWC Leave": [8],
          "Rehabilitation Privilege": [9],
          "Special Leave Benefits for Women": [10],
          "Special Emergency (Calamity) Leave": [11],
          "Adoption Leave": [12],
        };

        // Check if the current index should be rendered
        if (!leaveTypeIndexes[leaveType]?.includes(index)) {
          return null; // Skip rendering if index is not in the list
        }

        return (
          <React.Fragment key={index}>
            {dataPosition("✔", {
              left: "5.9rem",
              width: "1rem",
              top: `${
                index <= 1
                  ? 19.9 + index * 1.2
                  : 19.9 + 1 * 1.2 + (index - 1) * 1.1
              }rem`, // Apply different increments
              fontSize: "10px",
            })}
          </React.Fragment>
        );
      })}
      {/* 6B */}
      {object?.philippines && (
        <>
          {dataPosition("✔", {
            left: "27.2rem",
            width: "1rem",
            top: "21rem",
          })}
          {dataPosition(object?.abroadspecify, {
            left: "34.2rem",
            width: "9rem",
            top: "21rem",
          })}
        </>
      )}
      {object?.abroad && (
        <>
          {dataPosition("✔", {
            left: "27.2rem",
            width: "1rem",
            top: "22.1rem",
          })}
          {dataPosition(object?.abroadspecify, {
            left: "32.9rem",
            width: "10rem",
            top: "22.1rem",
          })}
        </>
      )}
      {object?.hospital && (
        <>
          {dataPosition("✔", {
            left: "27.2rem",
            width: "1rem",
            top: "24.4rem",
          })}
          {dataPosition(object?.inhospital, {
            left: "35.7rem",
            width: "7.5rem",
            top: "24.4rem",
          })}
        </>
      )}
      {object?.patient && (
        <>
          {dataPosition("✔", {
            left: "27.2rem",
            width: "1rem",
            top: "25.4rem",
          })}
          {dataPosition(object?.outpatient, {
            left: "36rem",
            width: "7.2rem",
            top: "25.5rem",
          })}
        </>
      )}
      {/* {object?.leaveType?.is_monetized && (
        <> */}
      {dataPosition("✔", {
        left: "27.2rem",
        width: "1rem",
        top: "35.6rem",
      })}
      {/* </>
      )} */}

      {/* 6C */}
      {/* {dataPosition(object?.duration, {
        left: "6.5rem",
        width: "14rem",
        top: "39.4rem",
      })}

      {dataPosition(
        `${formatDate(object?.startdate)} - ${formatDate(object?.enddate)}`,
        {
          left: "6.5rem",
          width: "14rem",
          top: "41.6rem",
        }
      )} */}

      {/* 7A */}
      {/* Vacation Leave */}
      {vacationLeave?.length > 0 &&
        object?.selectedType === "Vacation Leave" && (
          <>
            {dataPosition(
              parseFloat(vacationLeave[0]?.current) +
                parseFloat(object?.inputCredit || 0),
              {
                left: "13rem",
                width: "5.9rem",
                top: "48.4rem",
              }
            )}
            {dataPosition(object?.inputCredit || 0, {
              left: "13rem",
              width: "5.9rem",
              top: "49.1rem",
            })}
            {dataPosition(parseInt(vacationLeave[0]?.current, 10), {
              left: "13rem",
              width: "5.9rem",
              top: "50rem",
            })}
          </>
        )}
      {/* Sick Leave */}
      {sickLeave?.length > 0 && object?.selectedType === "Sick Leave" && (
        <>
          {dataPosition(
            parseFloat(sickLeave[0]?.current) +
              parseFloat(object?.inputCredit || 0),
            {
              left: "18.9rem",
              width: "5.9rem",
              top: "48.4rem",
            }
          )}
          {dataPosition(object?.inputCredit || 0, {
            left: "18.9rem",
            width: "5.9rem",
            top: "49.1rem",
          })}
          {dataPosition(parseInt(sickLeave[0]?.current, 10), {
            left: "18.9rem",
            width: "5.9rem",
            top: "50rem",
          })}
        </>
      )}

      {/* 7B */}
      {object?.forApproval && (
        <>
          {dataPosition("✔", {
            left: "27.2rem",
            width: "1rem",
            top: "46.3rem",
          })}
        </>
      )}
      {!object?.forApproval && (
        <>
          {dataPosition("✔", {
            left: "27.2rem",
            width: "1rem",
            top: "47.5rem",
          })}
        </>
      )}

      {/* 7C  */}
      {/* {isSickOrVacation && (
        <>
          {dataPosition(parseFloat(object?.inputCredit || 0), {
            left: "6.9rem",
            width: "2.5rem",
            top: "55.3rem",
          })}
          {dataPosition(
            parseInt(object?.duration, 10) -
              parseFloat(object?.inputCredit || 0),
            {
              left: "6.9rem",
              width: "2.5rem",
              top: "56.1rem",
            }
          )}
        </>
      )} */}
      {!isSickOrVacation && (
        <>
          {dataPosition(parseInt(object?.duration, 10) || "", {
            left: "6.9rem",
            width: "2.5rem",
            top: "57rem",
          })}
        </>
      )}

      {/* 7D  */}
      {dataPosition(object?.hrddRemarks, {
        left: "28.1rem",
        width: "14.9rem",
        whiteSpace: "normal",
        top: "55.3rem",
        fontSize: "10px",
        lineHeight: 1.3,
        maxHeight: `${10 * 1.3 * 3}px`, // Limit to 3 lines (fontSize * lineHeight * 3)
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 3, // Limits to 3 lines
        WebkitBoxOrient: "vertical",
      })}
    </div>
  );
}
